var _clipPath, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 815.0813648293963 811.9711286089239",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l815.08136 0l0 811.9711l-815.08136 0l0 -811.9711z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l815.08136 0l0 811.9711l-815.08136 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m107.75197 167.7441l0 0c0 -6.4621735 5.2386246 -11.70079 11.70079 -11.70079l0 0l0 0c3.103241 0 6.079376 1.2327576 8.273705 3.4270782c2.1943283 2.194336 3.4270859 5.170471 3.4270859 8.273712l0 528.315c0 6.462158 -5.2386246 11.700745 -11.70079 11.700745l0 0l0 0c-6.462166 0 -11.70079 -5.2385864 -11.70079 -11.700745z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 24,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m107.75197 167.7441l0 0c0 -6.4621735 5.2386246 -11.70079 11.70079 -11.70079l0 0l0 0c3.103241 0 6.079376 1.2327576 8.273705 3.4270782c2.1943283 2.194336 3.4270859 5.170471 3.4270859 8.273712l0 528.315c0 6.462158 -5.2386246 11.700745 -11.70079 11.700745l0 0l0 0c-6.462166 0 -11.70079 -5.2385864 -11.70079 -11.700745z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m636.06696 369.51837l0 0c0 -6.462158 5.2385864 -11.700775 11.700745 -11.700775l0 0l0 0c3.1032715 0 6.0794067 1.2327576 8.273743 3.427063c2.194275 2.194336 3.427063 5.170471 3.427063 8.273712l0 326.5512c0 6.462158 -5.2386475 11.700745 -11.700806 11.700745l0 0l0 0c-6.462158 0 -11.700745 -5.2385864 -11.700745 -11.700745z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 24,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m636.06696 369.51837l0 0c0 -6.462158 5.2385864 -11.700775 11.700745 -11.700775l0 0l0 0c3.1032715 0 6.0794067 1.2327576 8.273743 3.427063c2.194275 2.194336 3.427063 5.170471 3.427063 8.273712l0 326.5512c0 6.462158 -5.2386475 11.700745 -11.700806 11.700745l0 0l0 0c-6.462158 0 -11.700745 -5.2385864 -11.700745 -11.700745z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m647.7677 684.3583l0 0c6.462158 0 11.700806 5.2385864 11.700806 11.700806l0 0l0 0c0 3.1032104 -1.2327881 6.0793457 -3.427063 8.273682c-2.194336 2.194336 -5.170471 3.427063 -8.273743 3.427063l-528.31494 0c-6.462166 0 -11.70079 -5.2385864 -11.70079 -11.700745l0 0l0 0c0 -6.462219 5.2386246 -11.700806 11.70079 -11.700806z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 24,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m647.7677 684.3583l0 0c6.462158 0 11.700806 5.2385864 11.700806 11.700806l0 0l0 0c0 3.1032104 -1.2327881 6.0793457 -3.427063 8.273682c-2.194336 2.194336 -5.170471 3.427063 -8.273743 3.427063l-528.31494 0c-6.462166 0 -11.70079 -5.2385864 -11.70079 -11.700745l0 0l0 0c0 -6.462219 5.2386246 -11.700806 11.70079 -11.700806z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m706.89355 88.098526l0 0c4.566162 -4.566139 11.969299 -4.566139 16.535461 0l0 0l0 0c2.192749 2.1927338 3.4246216 5.1667175 3.4246216 8.267715c0 3.1009903 -1.2318726 6.0749817 -3.4246216 8.267715l-281.41733 281.4173c-4.5661316 4.5661316 -11.969299 4.5661316 -16.53543 0l0 0l0 0c-4.5661316 -4.5661316 -4.5661316 -11.969299 0 -16.53543z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m706.89355 88.098526l0 0c4.566162 -4.566139 11.969299 -4.566139 16.535461 0l0 0l0 0c2.192749 2.1927338 3.4246216 5.1667175 3.4246216 8.267715c0 3.1009903 -1.2318726 6.0749817 -3.4246216 8.267715l-281.41733 281.4173c-4.5661316 4.5661316 -11.969299 4.5661316 -16.53543 0l0 0l0 0c-4.5661316 -4.5661316 -4.5661316 -11.969299 0 -16.53543z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m703.7257 96.985565l0 0c0 -6.462166 5.2386475 -11.70079 11.700806 -11.70079l0 0l0 0c3.1032104 0 6.0794067 1.2327576 8.273682 3.4270859c2.194336 2.1943207 3.427124 5.1704636 3.427124 8.273705l0 208.18896c0 6.4621887 -5.2386475 11.700806 -11.700806 11.700806l0 0l0 0c-6.462158 0 -11.700806 -5.238617 -11.700806 -11.700806z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m703.7257 96.985565l0 0c0 -6.462166 5.2386475 -11.70079 11.700806 -11.70079l0 0l0 0c3.1032104 0 6.0794067 1.2327576 8.273682 3.4270859c2.194336 2.1943207 3.427124 5.1704636 3.427124 8.273705l0 208.18896c0 6.4621887 -5.2386475 11.700806 -11.700806 11.700806l0 0l0 0c-6.462158 0 -11.700806 -5.238617 -11.700806 -11.700806z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m715.4265 85.284775l0 0c6.462158 0 11.700806 5.2386246 11.700806 11.70079l0 0l0 0c0 3.103241 -1.2327881 6.079384 -3.427124 8.273705c-2.194275 2.1943207 -5.170471 3.4270782 -8.273682 3.4270782l-208.189 0c-6.462158 0 -11.700775 -5.238617 -11.700775 -11.700783l0 0l0 0c0 -6.462166 5.238617 -11.70079 11.700775 -11.70079z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m715.4265 85.284775l0 0c6.462158 0 11.700806 5.2386246 11.700806 11.70079l0 0l0 0c0 3.103241 -1.2327881 6.079384 -3.427124 8.273705c-2.194275 2.1943207 -5.170471 3.4270782 -8.273682 3.4270782l-208.189 0c-6.462158 0 -11.700775 -5.238617 -11.700775 -11.700783l0 0l0 0c0 -6.462166 5.238617 -11.70079 11.700775 -11.70079z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m446.00394 156.0433l0 0c6.462158 0 11.700775 5.238617 11.700775 11.70079l0 0l0 0c0 3.103241 -1.2327576 6.079376 -3.427063 8.273712c-2.194336 2.1943207 -5.170471 3.4270782 -8.273712 3.4270782l-326.55118 0c-6.462166 0 -11.70079 -5.238617 -11.70079 -11.70079l0 0l0 0c0 -6.4621735 5.2386246 -11.70079 11.70079 -11.70079z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 24,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m446.00394 156.0433l0 0c6.462158 0 11.700775 5.238617 11.700775 11.70079l0 0l0 0c0 3.103241 -1.2327576 6.079376 -3.427063 8.273712c-2.194336 2.1943207 -5.170471 3.4270782 -8.273712 3.4270782l-326.55118 0c-6.462166 0 -11.70079 -5.238617 -11.70079 -11.70079l0 0l0 0c0 -6.4621735 5.2386246 -11.70079 11.70079 -11.70079z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.c88b148baaa570266517d4bbf57a043d.svg";
export { ForwardRef as ReactComponent };